import { postAiImageGenerateAiImage } from "api"
import { useRouter } from "next/router"
import {
  Dispatch,
  FC,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react"

export type CreateAiContextType = {
  propertiesData: number[]
  setPropertiesData: Dispatch<SetStateAction<number[]>>
  stylesData: number
  setStylesData: Dispatch<SetStateAction<number>>
  backgroundsData: number
  setBackgroundsData: Dispatch<SetStateAction<number>>
  senderBlessingAi: string
  setSenderBlessingAi: Dispatch<SetStateAction<string>>
  blessingId: number
  setBlessingId: Dispatch<SetStateAction<number>>
  imageGuid: string
  setImageGuid: Dispatch<SetStateAction<string>>
  responseImageUrl: string
  setResponseImageUrl: Dispatch<SetStateAction<string>>
  sessionId: string
  setSessionId: Dispatch<SetStateAction<string>>
  postAiImage: () => Promise<void>
  limitAiImages: number
  setLimitAiImages: Dispatch<SetStateAction<number>>
}

export const CreateAiContext = createContext<CreateAiContextType>(null)

export const CreateAiContextProvider: FC = ({ children }) => {
  const [propertiesData, setPropertiesData] = useState<number[]>([])
  const [stylesData, setStylesData] = useState<number>()
  const [backgroundsData, setBackgroundsData] = useState<number>()
  const [senderBlessingAi, setSenderBlessingAi] = useState<string>("")
  const [blessingId, setBlessingId] = useState()
  const [imageGuid, setImageGuid] = useState("")
  const [responseImageUrl, setResponseImageUrl] = useState("")
  const [sessionId, setSessionId] = useState("")
  const [limitAiImages, setLimitAiImages] = useState(0)
  const router = useRouter()
  const postAiImage = async () => {
    try {
      router.push("/create-ai/loading")
      const res = await postAiImageGenerateAiImage({
        sessionId: sessionId,
        blessingId: blessingId,
        tagsIds: [...propertiesData, stylesData, backgroundsData],
        blessingText: senderBlessingAi,
      })

      if (res.data.errorCode === 0) {
        // OK
        router.push("/create-ai/choose-picture")
        setImageGuid(res.data.body[0].imageGuid)
        setResponseImageUrl(res.data.body[0].url)
      } else {
        // ERROR
        if (res.data.errorCode === 9000) {
          router.push("/create-ai/error?type=specific")
          return
        }
        router.push("/create-ai/error?type=general")
      }
    } catch {
      console.log("catch")
      router.push("/create-ai/error?type=general")
    }
  }

  return (
    <CreateAiContext.Provider
      value={{
        propertiesData,
        setPropertiesData,
        stylesData,
        setStylesData,
        backgroundsData,
        setBackgroundsData,
        senderBlessingAi,
        setSenderBlessingAi,
        blessingId,
        setBlessingId,
        imageGuid,
        setImageGuid,
        responseImageUrl,
        setResponseImageUrl,
        sessionId,
        setSessionId,
        postAiImage,
        limitAiImages,
        setLimitAiImages,
      }}
    >
      {children}
    </CreateAiContext.Provider>
  )
}

export const useCreateAiContext = () => useContext(CreateAiContext)
